/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2017, 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'underscore',
	'../lib/@waca/core-client/js/core-client/ui/core/View',
	'../lib/@waca/core-client/js/core-client/utils/ClassFactory',
	'../filters/finder/FilterModuleFinder',
	'../filters/FilterMetadataHelper'
], function(_, View, ClassFactory, FilterModuleFinder, FilterMetadataHelper) {

	var Wrapper = View.extend({

		className: 'localFilterViewWrapper',

		init: function(options) {
			Wrapper.inherited('init', this, arguments);
			this.options = options.state || options;
			this.showBoxShadow = this.options.showBoxShadow;
			this.logger = this.options.dashboardApi.getGlassCoreSvc('.Logger');
		},

		// Need to preload to have the Flyout sized properly.
		preload: function() {
			var moduleOptions = {
				origin: 'localFilter'
			};

			let metadata = FilterMetadataHelper.getFilterMetadataInfo(this.options.metadataColumn, this.options.slot,  this.options.mapIndex);
			_.extend(moduleOptions, metadata);

			//TODO: For legacy reasons, the metadata info is needed on 'this.options' as well.
			//Metadata info can be access from the controller using this.metadataInfo.
			//When the code is cleaned up, then this line can be deleted.
			_.extend(this.options, metadata);

			const dataSources = this.options.dashboardApi.getFeature('dataSources.deprecated');
			moduleOptions.dataSources = dataSources;
			return FilterModuleFinder.getModule(moduleOptions)
				.then(function(module) {
					return ClassFactory.loadModule(module);
				})
				.then(function(FilterController) {
					this.options.commonView = this;
					this.filterController = new FilterController(this.options);
					return this.filterController.initialize()
						.catch(function(e){
							this.logger.error(e);
						}.bind(this));
				}.bind(this));
		},

		remove: function() {
			if (!this._removing) {
				this._removing = true;
				if(this.toolbar && this.toolbar.flyout){
					this.toolbar.flyout.close();
				}
				if (this.filterController) {
					this.filterController.remove();
					this.filterController = null;
				}

				Wrapper.inherited('remove', this, arguments);
			}
		},

		renderInFilterItemView: function(viewModel) {
			if(viewModel && viewModel.viewClass){
				this.$el.addClass(viewModel.viewClass);
			}

			var viewOptions = {
				mountNode: this.$el.get(0)
			};
			return Promise.resolve(viewOptions);
		},

		renderCallBack: function(toolbar) {
			this.setToolBar(toolbar);
			return Promise.resolve();
		},

		onViewClose: function() {
			this.remove();
		},

		onFlyoutClose: function() {
			if(this.filterController && this.filterController.onClose && !this.filterController.closed){
				this.filterController.onClose();
			}
		},

		bindFlyoutClose: function(toolbar) {
			toolbar.on('flyout:hide', this.onFlyoutClose.bind(this));
			toolbar.on('toolbar:show', this.onFlyoutShow.bind(this));
		},

		_renderFilterInstance: function(){
			if(this.filterController) {
				return this.filterController.render();
			}
			return Promise.resolve();
		},

		setToolBar: function(toolbar){
			this.toolbar = toolbar;
			this.bindFlyoutClose(toolbar);
		},

		onFlyoutShow: function() {
			return this._renderFilterInstance();
		}
	});

	return Wrapper;
});
